import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';

// Pages
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import CartPage from './pages/CartPage';
import QuickCheckoutPage from './pages/QuickCheckoutPage';
import AboutPage from './pages/AboutPage';
import AdminPage from './pages/AdminPage';

import './App.css';

const TOAST_OPTIONS = {
  style: {
    fontFamily: 'DM Sans, sans-serif',
  },
};

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<QuickCheckoutPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={TOAST_OPTIONS}
        />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
